<template>
  <TableBodyRow
    :thead="thead"
    class="combosrow gw_table_body_row_hoverable cursor-default"
  >
    <TableBodyCell
      thKey="card"
      class="drillscell gw_table_body_cell_sticky"
    >
      <CardSymbols
        :colorDefault="true"
        :cardsIds="item.id"
        style="--size: 1rem"
      />
    </TableBodyCell>
    <TableBodyCell
      v-for="(action, key, index) in thActions"
      :key="key"
      :ref="`cell_${key}`"
      class="drillscell"
      :thKey="key"
      style="--padding-td: 0"
      @mouseleave="$emit('mouseleave:cell')"
      @mouseenter="
        $emit('mouseenter:cell', {
          el: $refs[`cell_${key}`],
          action,
          index,
          value: item.actions[index],
        })
      "
    >
      <div
        v-if="item.actions[index] && !item.actions[index].unimportant"
        class="position-absolute w-100"
        style="left: 0; height: 100%"
        :style="`background:var(${item.actions[index].color});`"
      />
      <div
        v-if="item.actions[index]"
        class="f-center position-absolute w-100"
        style="text-shadow: var(--text-shadow_drop); left: 0; height: 100%"
        :class="{ 'clr-grey': item.actions[index].unimportant }"
      >
        <!-- we want 0.00 here (2 zeros) -->
        <span
          v-if="Math.abs(item.actions[index].blocked_frequency * 100).toFixed(2) !== '0.00'"
          class="text-medium line-height_1 my-auto pr-1"
        >
          {{ item.actions[index].blocked_frequency > 0 ? '+' : '-' }}
        </span>
        {{ Math.abs(item.actions[index].blocked_frequency * 100).toFixed(2) }}%
      </div>
    </TableBodyCell>
    <TableBodyCell
      style="order:99,--padding-td: 0"
      class="role_spacer"
    >
    </TableBodyCell>
  </TableBodyRow>
</template>

<script>
import CardSymbols from '@/components/CardSymbols/CardSymbols'
import TableBodyRow from '@/components/DataTables/v2/TableBodyRow'
import TableBodyCell from '@/components/DataTables/v2/TableBodyCell'
import table_mix from '@/components/DataTables/table_mix'

export default {
  name: 'BlockersTableRow',
  components: {
    TableBodyRow,
    TableBodyCell,
    CardSymbols,
  },
  mixins: [table_mix],
  props: {
    item: Object,
    index: Number,
    thead: Object,
    thActions: Object,
  },
  emits: ['mouseleave:cell', 'mouseenter:cell'],
}
</script>
